import { FeatureGate } from '@statsig/client-core'

// SDK forces loadingStatus to 'Ready' even when the network fetch fails
// (NoValues / Uninitialized / Error:NoClient reasons), so the reason must
// be checked too -- readiness alone would fail open.
const TRUSTED_REASON_REGEX = /^(Network|NetworkNotModified|Cache|Bootstrap|Prefetch):Recognized$/

export interface FailSecureGateArgs {
   isStatsigReady: boolean
   gate: FeatureGate
}

export const isTrustedEvaluation = (reason: string): boolean =>
   TRUSTED_REASON_REGEX.test(reason)

export const getFailSecureGateValue = (args: FailSecureGateArgs): boolean => {
   const { isStatsigReady, gate } = args
   if (isStatsigReady && isTrustedEvaluation(gate.details.reason)) {
      return gate.value
   }
   return false
}
